import { parseTime } from '@/utils/util'
export const searchForm = {
  name: '', // 名称
  is_jump_qq: undefined, // 是否跳转QQ
  business_id: undefined, // 业务线id
}

export const form = {
  name: '', // 名称
  identify: '', // 唯一标识
  business_id: undefined, // 平台ID
  is_jump_qq: 0, // 是否跳转QQ
  jump_link: '', // 跳转地址
  introduce_js: '', // 引入JS
}

const valIdentify = (rule, value, callback) => {
  const pattern = new RegExp(/[\u4E00-\u9FA5]/g)
  if (value === '') {
    callback(new Error('请输入唯一标识'))
  } else {
    if (value !== '' && pattern.test(value)) {
      callback(new Error('不能输入汉字'))
    }
    callback()
  }
}

export const rules = {
  name: [{ required: true, message: '请输入网站名称', trigger: 'change' }],
  identify: [{ required: true, validator: valIdentify, trigger: 'change' }],
  business_id: [{ required: true, message: '请选择业务线', trigger: 'change' }],
  is_jump_qq: [{ required: true, message: '请选择是否跳转', trigger: 'change' }],
  jump_link: [{ required: true, message: '请输入', trigger: 'change' }],
}

export const columns = [
  {
    title: '序号',
    dataIndex: 'id',
    width: 70,
    align: 'center'
  },
  {
    title: '发布平台',
    dataIndex: 'org',
    width: 180,
    align: 'left',
    scopedSlots: { customRender: 'org' }
  },
  {
    title: '网站名称',
    dataIndex: 'name',
    width: 140,
    align: 'left',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '跳转QQ',
    dataIndex: 'is_jump_qq',
    width: 90,
    align: 'center',
    scopedSlots: { customRender: 'is_jump_qq' }
  },
  {
    title: '跳转链接',
    dataIndex: 'jump_link',
    width: 220,
    align: 'left',
    scopedSlots: { customRender: 'jump_link' }
  },
  {
    title: '引入JS',
    dataIndex: 'introduce_js',
    width: 220,
    align: 'left',
    scopedSlots: { customRender: 'introduce_js' }
  },
  {
    title: '唯一标识',
    dataIndex: 'identify',
    width: 140,
    align: 'left',
    scopedSlots: { customRender: 'identify' }
  },
  {
    title: '备注',
    dataIndex: 'remark',
    width: 160,
    align: 'left',
    scopedSlots: { customRender: 'remark' }
  },
  {
    title: '创建时间/更新时间',
    dataIndex: 'create_at',
    align: 'left',
    width: 200,
    scopedSlots: { customRender: 'create_at' }
  },
  {
    title: '操作人',
    dataIndex: 'create_number',
    width: 80,
    align: 'left',
    scopedSlots: { customRender: 'create_number' }
  },
  {
    title: '操作',
    dataIndex: 'operator',
    align: 'center',
    width: 100,
    scopedSlots: { customRender: 'operator' }
  }
]
